import type { components } from "@certn/api/generated-schemas/client-portal";
import {
  BasicButton,
  Modal,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export type BillingProfilePaymentProfileChangePreviewBalance =
  components["schemas"]["BillingProfilePaymentProfileChangePreviewBalance"];

interface Props {
  isOpen: boolean;
  currencyBreakdown: BillingProfilePaymentProfileChangePreviewBalance[];
  onCancel: () => void;
  onSaveWithoutCharging: () => void;
  onSaveAndCharge: () => void;
}

export function PaymentProfileChangeConsentModal({
  isOpen,
  currencyBreakdown,
  onCancel,
  onSaveWithoutCharging,
  onSaveAndCharge,
}: Props) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} testID="payment-profile-change-consent-modal">
      <Dialog>
        <>
          <DialogHeader onClose={onCancel}>
            {t("Charge open invoices?")}
          </DialogHeader>
          <DialogContent>
            <Stack gap="space-4">
              <Text style="global/body-primary">
                {t(
                  "You have open invoices on this billing profile. Would you like to charge them with the new card now? You will be charged for each invoice as a separate transaction."
                )}
              </Text>
              <ul>
                {currencyBreakdown.map((row) => (
                  <li key={`${row.currency}-${row.total_balance}`}>
                    <Text style="global/body-primary">
                      {row.currency} {row.total_balance}
                    </Text>
                  </li>
                ))}
              </ul>
            </Stack>
          </DialogContent>
          <DialogFooter>
            <BasicButton onPress={onSaveWithoutCharging}>
              {t("Save without charging")}
            </BasicButton>
            <PrimaryButton onPress={onSaveAndCharge}>
              {t("Save and charge")}
            </PrimaryButton>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
}
